import { Injectable } from '@angular/core';
import { BaseItemModelService } from './base-item.model';
import { isDefined } from '@fi-shared/utils/is-defined';
import { TemplateControlType } from './types/template-control-type';
import { FiDocumentTemplateItemViewSimpleTextComponent } from '../document-template/document-template-item-view/document-template-item-view-simple-text.component';
import { FiDocumentTemplateItemOptionsSimpleTextComponent } from '../document-template/document-template-item-options/document-template-item-options-simple-text/document-template-item-options-simple-text.component';
import { TemplatePlaceHolderControlModel } from '@fi-app/template/template-placeholder-control.model';

@Injectable()
export class SimpleTextModelService {
    simpleTextItem: BaseItemModelService;
    model: TemplatePlaceHolderControlModel;

    //Settings: any;

    constructor(baseItemModel: BaseItemModelService) {
        this.simpleTextItem = Object.create(baseItemModel);
        this.simpleTextItem.init(
            'simpleText',
            TemplateControlType.PlainText,
            FiDocumentTemplateItemViewSimpleTextComponent,
            FiDocumentTemplateItemOptionsSimpleTextComponent,
            'simpleText',
            'align-justifyCcmIcon',
            function (instance) {
                instance.model.Contents.forEach(function (content) {
                    content.Value.Text = '';
                    content.Value.AdditionalText = '';
                });
            },
        );

        Object.assign(this, this.simpleTextItem);
    }

    IsEmpty(contentLanguageId: number) {
        const content = this.model.Contents.find((c) => c.ContentLanguageId === contentLanguageId);
        if (!content) return true;

        if (isDefined(content.Value.Text) && content.Value.Text.length > 0) {
            return false;
        }

        if (
            this.model.Settings &&
            this.model.Settings.Columns == this.simpleTextItem.config.COLUMNS.TWO.id &&
            isDefined(content.Value.AdditionalText) &&
            content.Value.AdditionalText.length > 0
        ) {
            return false;
        }
        return true;
    }

    create() {
        return this.simpleTextItem.create.call(this.simpleTextItem);
    }
}
